import Button from 'components/Button';
import BPointIcon from '../Icons/BPointIcon';
import BackgroundSection from './BackgroundSection';
import { useTheme } from '../hooks/useTheme';
import useMediaQuery from 'hooks/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';
const Brochure = ({ data }) => {
  const { isDarkMode } = useTheme();
  const isMobileSize = useMediaQuery();
  const navigate = useNavigate();
  return (
    <div
      className={`${isMobileSize ? '' : 'full-pager'} flex brochure-wrapper`}
    >
      <div className='brochure-description row-gap-30 flex flex-column justify-between'>
        <div className='brochure-icon-wrapper'>
          <BPointIcon
            width='100%'
            height='100%'
            color={isDarkMode ? '#E8E2D6' : '#F9F7F2'}
          />
        </div>
        <div className='brochure-content row-gap-30 flex flex-column'>
          <p className='uppercase full-width sec-nd-hp-p font-size-24 line110-ls024 font-primary balanced-text'>
            {renderWithLineBreaks(data?.title)}
            <span className='font-secondary color-unset'>
              {renderWithLineBreaks(data?.titleHighlight)}
            </span>
          </p>
          <p className='paragraph-font-grotesk'>{data?.description}</p>
          {data?.buttonText && data?.buttonLink && (
            <Button
              variant={isDarkMode ? '' : 'dark'}
              showIcon={true}
              onClick={() => navigate(data?.buttonLink)}
            >
              {data?.buttonText}
            </Button>
          )}
        </div>
      </div>
      <BackgroundSection
        imageUrl={
          isDarkMode
            ? data?.darkModeImageUrl || data?.lightModeImageUrl
            : data?.lightModeImageUrl
        }
        alt='about-brochure'
        bgClassName='full-height full-width'
      />
    </div>
  );
};

export default Brochure;
